export default __webpack_public_path__ + "static/media/sandeep.22c92b62.png";